import { Component, OnInit } from '@angular/core';
import { ProductOptionWithSubrole } from '@app/core/interfaces/product-option-with-subrole';
import { PortalError } from '@app/utils/error/portal-error';
import { ProductOptionService } from '@business/product-option/product-option.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-product-option-page',
  templateUrl: './product-option-page.component.html',
  styles: [],
  standalone: false,
})
export class ProductOptionPageComponent implements OnInit {
  error$: Observable<PortalError | null>;
  loading$: Observable<boolean>;
  viewModel$: Observable<ProductOptionWithSubrole[]>;

  constructor(private productOptionService: ProductOptionService) {}

  ngOnInit(): void {
    this.error$ = this.productOptionService.productOptions.error$.pipe(untilDestroyed(this));
    this.loading$ = this.productOptionService.productOptions.loading$.pipe(untilDestroyed(this));
    this.viewModel$ = this.productOptionService.productOptions.data$.pipe(untilDestroyed(this));
  }

  refresh(): void {
    this.productOptionService.productOptions.reload();
  }
}
